import { parentNodeTypes } from '@constants/canvas/general';
import { SubLayerTypes } from '@constants/canvas/layers';
import { useProject } from '@context/Project/ProjectProvider';
import { matchesModelFiltersDto } from '@context/ProjectFilters/matchesModelFilters';
import { useProjectFilters } from '@context/ProjectFilters/ProjectFiltersProvider';
import { useToast } from '@context/Toast/ToastProvider';
import { NodeDTO } from '@store/services/nodes/types';
import { useQuestionnaireResult } from '@store/zustand/questionnaire-result';
import { checkScopeFilter } from '@utils/domains';

const useEntityVisibilityCheck = () => {
  const {
    toolbox: { domains },
  } = useProject();
  const { showToast } = useToast();
  const {
    validationStatus,
    reviewStatus,
    operationalStatuses,
    operatingModelStatuses,
    partners,
    ciaFilters,
  } = useProjectFilters();
  const { result: questionnaireResult } = useQuestionnaireResult();

  const checkIsEntityBecameHidden = (node: NodeDTO) => {
    const subLayer = parentNodeTypes[node.type] as SubLayerTypes | undefined;

    const isEntityVisible =
      (!domains.length ||
        checkScopeFilter(domains, node.type, node.domainNodes)) &&
      matchesModelFiltersDto(
        node,
        subLayer,
        {
          validationStatus,
          reviewStatus,
          operationalStatuses,
          operatingModelStatuses,
          partners,
          ciaFilters,
        },
        { questionnaireResult: Boolean(questionnaireResult) },
      );

    if (!isEntityVisible) {
      showToast(
        'To make it visible please select the appropriate filtering options.',
        'success',
        { header: 'Entity saved successfully, but not visible.' },
      );
    }

    return !isEntityVisible;
  };

  return { checkIsEntityBecameHidden };
};

export default useEntityVisibilityCheck;
